import { FunctionComponent, useState } from 'react'
import DashboardLayout from '../../components/layout/layout'
import { Button, Checkbox, Grid, Paper, Skeleton, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import { useGetChannelPartnerOEntryHeaderSetPoint } from '../../hooks/api/oms';
import StorageService from '../../services/storageService';

const TableCol = styled(TableCell)(({ theme }) => ({
  border: '1px solid rgba(224, 224, 224, 1)',
}));

const CheckboxUI = styled(Checkbox)(({ theme }) => ({
  '&.Mui-checked': {
    color: '#c3183c',
  },
}));

const OnlineOrderEntryAddProductSetPoint: FunctionComponent = () => {
  const navigate = useNavigate();
  const { productNumber, productQuantity } = useParams();
  const [selectedRecordId, setSelectedRecordId] = useState<string | null>(null);
  const { data: setPoints, isFetched: hasFetched } = useGetChannelPartnerOEntryHeaderSetPoint(productNumber || '');

  const toggleCheck = (recordId: string) => {
    setSelectedRecordId(prev => (prev === recordId ? null : recordId));
    // StorageService.setOEntryHeaderSetPointValue(setPoints?.setPoints?.find((setPoint: any) => setPoint.partNumber === recordId) || {});
    const selectedSetPoint = setPoints?.data?.setPoints?.find((setPoint: any) => setPoint.partNumber === recordId);
    
    // Convert listPrice to string to maintain consistency
    if (selectedSetPoint) {
      selectedSetPoint.listPrice = selectedSetPoint.listPrice?.toString() || '';
    }
    
    StorageService.setOEntryHeaderSetPointValue(selectedSetPoint || {});
    navigate('/order-management-system/online-order-entry/add-product/' + productNumber + '/' + productQuantity);
  };

  return (
    <DashboardLayout title={"Orders Management"} initialBreadcrumbs={"Channel Partners"} levelBreadcrumbs={"Online Order Entry"} breadcrumbs={'Add products 1'} activeMenu={'oms'}>
      <Typography variant="body1" mb={1}>
        Product number {productNumber} requires a set point.
      </Typography>
      <Typography variant="body1" mb={3}>
        Please choose from the following options. If the require set point is not available please contact Custome Care.
      </Typography>

      <TableContainer component={Paper} variant="outlined" sx={{borderRadius: 0}}>
        <Table size="small" aria-label="inventory list table">
          <TableHead sx={{ backgroundColor: "#ebebeb"}}>
            <TableRow>
              {['Base Part Number', 'Part Number', 'Set Point', 'Select'].map((heading) => (
                <TableCol key={heading} sx={{ color: '#000000', fontWeight: 'bold' }}>
                  {heading}
                </TableCol>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {
              hasFetched ? (
                setPoints?.data?.setPoints?.length === 0 ?
                  <TableRow>
                    <TableCol colSpan={4}>
                      No Data Found
                    </TableCol>
                  </TableRow>
                : setPoints?.data?.setPoints?.map((setPoint: any, idx: number) => (
                  <TableRow key={setPoint.setPoint} hover>
                    <TableCol>{productNumber}</TableCol>
                    <TableCol>{setPoint.partNumber}</TableCol>
                    <TableCol>{setPoint.setPoint}</TableCol>
                    <TableCol>
                      <CheckboxUI
                        color="secondary"
                        checked={selectedRecordId === setPoint.partNumber}
                        onChange={() => toggleCheck(setPoint.partNumber)}
                      />
                    </TableCol>
                  </TableRow>
                ))
              ) : (
                <>
                  <TableRow>
                    <TableCol colSpan={4}>
                      <Skeleton width="38%" />
                      <Skeleton width="100%" />
                      <Skeleton width="100%" />
                      <Skeleton width="61%" />
                    </TableCol>
                  </TableRow>
                </>
              )
            }
          </TableBody>
        </Table>
      </TableContainer>

      <Grid size={12} sx={{ mt: 4 }}>
        <Button variant="contained" sx={{ backgroundColor: '#c3183c', padding: '6px 25px !important', minWidth: '110px' }} onClick={() => {
          // If no set points are available, store 'N/A' before navigating back
          if (setPoints?.data?.setPoints?.length === 0) {
            StorageService.setOEntryHeaderSetPointValue({
              partNumber: productNumber,
              setPoint: 'N/A',
              listPrice: 'Call Customer Care for pricing: (800) 835-1060',
              description: setPoints?.data?.baseDescription,
            });
          }
          navigate('/order-management-system/online-order-entry/add-product/' + productNumber + '/' + productQuantity);
        }}>
          BACK
        </Button>
      </Grid>
    </DashboardLayout>
  )
}

export default OnlineOrderEntryAddProductSetPoint